


































































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';

import { config } from './config';
import { locales } from './locales';

import { customizable } from '../../../mixins/customizable';

const Props = Vue.extend({
	props: {
		/** Label of the value */
		label: {
			type: String,
			required: true
		},
		/** Value to display */
		value: {
			type: [String, Number],
			default: undefined
		},
		/** Action to display */
		action: {
			type: String,
			default: undefined
		},
		/** Text to display as fallback of value */
		placeholder: {
			type: String,
			default: locales.placeholder
		},
		/** Display the value in a VChip */
		chip: {
			type: Boolean,
			default: false
		},
		/** SVG icon to display */
		icon: {
			type: String,
			default: undefined
		},
		/** Display label & value on a single line */
		row: {
			type: Boolean,
			default: false
		},
		/** Render the value as plain HTML */
		renderHtmlValue: {
			type: Boolean,
			default: false
		}
	}
});

const MixinsDeclaration = mixins(Props, customizable(config));

/**
 * DataListItem is a component that displays a
 * label associated with a value
 */
@Component
export default class DataListItem extends MixinsDeclaration {
	get labelColor(): string {
		return this.$vuetify.theme.dark ? 'rgba(255, 255, 255, .7)' : 'rgba(0, 0, 0, .6)';
	}

	get itemValue(): string {
		if (typeof this.value === 'number') {
			return isNaN(this.value) ? this.placeholder : this.value.toString();
		}

		return this.value || this.placeholder;
	}
}
